/**
 * Format numbers depending on currency and locale.
 * Note that up to Node 13, only the locale en-US is suppported. If you use a different one, it will default to en-US
 */
export default function formatCurrency ( amount: number, currency = "EUR", locale = "nl-NL" ): string {
    const formatter = new Intl.NumberFormat( locale, { style: "currency", currency } )
    return formatter.format( amount )
}
